export function formatDate(date: string | Date, withTime: boolean = false) {
  return new Intl.DateTimeFormat('uk', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: withTime ? 'numeric' : undefined,
    minute: withTime ? 'numeric' : undefined,
    hour12: false,
    timeZone: 'Europe/Kyiv',
  }).format(typeof date === 'string' ? new Date(date) : date);
}
